import React from "react";
import { InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { Search } from "@mui/icons-material";

interface Props {
  ctnStyle?: React.CSSProperties;
}

type ExtendedProps = Props & TextFieldProps

function CustomSearchBar({ ctnStyle, ...rest }: ExtendedProps) {
  return (
    <TextField
      id="input-with-icon-textfield"
      type="search"
      size="small"
      color="secondary"
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <Search
              style={{
                color: "gray",
                opacity: 0.5,
                width: "100%",
                fontSize: 35,
              }}
            />
          </InputAdornment>
        ),
        style: { borderRadius: 5 },
      }}
      variant="outlined"
      style={{
        marginRight: "1em",
        width: "50%",
        ...ctnStyle
      }}
      {...rest}
    />
  );
}

export default CustomSearchBar;
